import { state as base_state } from "../../base/store/state";

export function state() {
	return base_state();
}
